// extracted by mini-css-extract-plugin
export var button = "_d-0";
export var buttonContent = "_d-e";
export var buttonGroup = "_d-c";
export var dontRestrainIconWidth = "_d-a";
export var dropdownButton = "_d-b";
export var iconContainer = "_d-9";
export var lg = "_d-4";
export var md = "_d-3";
export var pending = "_d-f";
export var sm = "_d-2";
export var spinner = "_d-d";
export var squared = "_d-8";
export var wrapText = "_d-g";
export var xl = "_d-5";
export var xs = "_d-1";
export var xxl = "_d-6";
export var xxxl = "_d-7";